module.exports = __webpack_public_path__ + "img/green_063.be8869a9.png";